import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from '@node-space/hooks'
import { postAddCustomerWalletV1, postAddCustomerWalletV2 } from 'services/CustomerService'
import type {
  AddCustomerWalletRequestV1,
  AddCustomerWalletRequestV2,
  WalletResponse,
} from 'types/customers'

export const useAddCustomerWalletRequest = () => {
  const { enableWalletCreationV2 } = useFeatureFlags()

  const mutationFn = (
    wallet: AddCustomerWalletRequestV1 | AddCustomerWalletRequestV2
  ): Promise<WalletResponse> => {
    if (enableWalletCreationV2) {
      return postAddCustomerWalletV2(wallet as AddCustomerWalletRequestV2)
    }
    return postAddCustomerWalletV1(wallet as AddCustomerWalletRequestV1)
  }

  return useMutation({
    mutationFn,
  })
}
